const ListArtistPage = function () {
  return <>LIST ARTIST</>;
};

export default ListArtistPage;
